<template lang="pug">
.retailers
  loading(v-if="!content")

  article.page__article.pd-article(
    v-else
    data-aos="fade-in"
    v-html="contentHtml")
</template>

<script>
import { marked } from 'marked'

export default {
  scrollToTop: true,

  data () {
    return {
      content: null
    }
  },

  fetch () {
    return this.fetch()
  },

  head () {
    return this.$seo.head({
      title: 'Terms of service - For Vendors',
      description: 'Learn more about Pod Food\'s Terms of Service for Vendors here.'
    })
  },

  computed: {
    contentHtml () {
      if (!this.content) return ''
      return marked.parse(this.content)
    }
  },

  methods: {
    fetch () {
      return this.$api.vendor
        .getTermsOfService()
        .then(res => {
          this.content = res.content
        })
    }
  }
}
</script>
